import React, { useContext, useEffect, useState } from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import InputMask from 'react-input-mask';

import { UserContext } from '../../UserContext';
import { useHttpClient } from '../hooks/useHttpClient';
import { useNotificacoes } from '../hooks/useNotificacoes';

import styles from './CadastroUsina.module.css';
import styles_global from '../css/global.module.css';
import styles_content from '../css/main-content.module.css';
import {formatarKwh10_2} from "../../util/validacoes";

function DetalharUsina() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { get } = useHttpClient();
    const { exibirErro } = useNotificacoes();
    const { user } = useContext(UserContext);
    const [showSenha, setShowSenha] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [tiposUsina, setTiposUsina] = useState([]);

    const [formData, setFormData] = useState({
        idUsuarioProprietario: '',
        idEmpresa: '',
        cnpj: '',
        idTipoUsina: '',
        nome: '',
        email: '',
        emailContabilidade:'',
        telefone: '',
        endereco: '',
        codCliente: '',
        potencia: '',
        complementoEndereco: '',
        bairro: '',
        municipio: '',
        uf: '',
        cep: '',
        chaveAsaas: '',
        numeroCarteira: '',
        chavePix: '',
        tipoChavePix: '',
        cpfResponsavel: '',
        senhaDistribuidora: ''
    });

    useEffect(() => {
        carregarDados();
    }, [id]);

    useEffect(() => {
        if (String(formData.idTipoUsina) === '2') {
            setShowSenha(false); // opcional: volta o olho para “oculto”
            setFormData(prev => ({
                ...prev,
                cpfResponsavel: '',
                senhaDistribuidora: ''
            }));
        }
    }, [formData.idTipoUsina]);

    const carregarDados = async () => {
        try {
            const empresaId = user?.empresa?.id;

            const [empresasData, usuariosData, tiposUsina] = await Promise.all([
                get (`/hello-sol/empresas/lista/${empresaId}`),
                get (`/hello-sol/usuarios/buscar?idEmpresa=${empresaId}&idTipoUsuario=1`),
                get(`/hello-sol/tipos-usina`)

            ]);

            setEmpresas(empresasData);
            setUsuarios(usuariosData);
            setTiposUsina(tiposUsina);

            if (id) {
                const data = await get (`/hello-sol/usinas/${id}`);
                setFormData({
                    ...data,
                    cnpj: formatarCNPJ(data.cnpj),
                    telefone: formatarTelefone(data.telefone),
                    idEmpresa: data.empresaGestora?.id,
                    idUsuarioProprietario: data.usuarioProprietario?.id
                });
            }
        } catch (e) {
            exibirErro('Erro ao carregar dados da usina: ' + e.message);
        }
    };

    const formatarCNPJ = (valor) => {
        return valor.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    };

    const formatarTelefone = (valor) => {
        if (valor.length === 10) {
            return valor.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
        }
        return valor.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    };

    const getPixMask = () => {
        switch (formData.tipoChavePix) {
            case '1': return '999.999.999-99';
            case '2': return '99.999.999/9999-99';
            case '3': return '(99) 99999-9999';
            default: return '';
        }
    };

     return (
        <div className={styles_global.container}>
            <h2>Detalhar Usina</h2>
            <form>
                {/* Linha Empresa e CNPJ */}
                <div className={styles.linhaUsina3}>
                    <div className={styles_content.formField}>
                        <label htmlFor="idEmpresa">Empresa</label>
                        <select name="idEmpresa" value={formData.idEmpresa} disabled>
                            <option value="">Selecionar Empresa</option>
                            {empresas.map((empresa) => (
                                <option key={empresa.id} value={empresa.id}>{empresa.nome}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="cnpj">CNPJ</label>
                        <InputMask
                            mask="99.999.999/9999-99"
                            maskChar=""
                            type="text"
                            name="cnpj"
                            value={formData.cnpj}
                            disabled
                        />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="nome">Nome</label>
                        <input type="text" name="nome" value={formData.nome} disabled/>
                    </div>
                </div>

                {/* Linha Nome, Email, Telefone */}
                <div className={styles.linhaUsina3}>
                    <div className={styles_content.formField}>
                        <label htmlFor="email">Email</label>
                        <input type="email" name="email" value={formData.email} disabled/>
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="telefone">Telefone</label>
                        <InputMask
                            mask="(99) 99999-9999"
                            maskChar=""
                            type="text"
                            name="telefone"
                            value={formData.telefone}
                            disabled
                        />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="emailContabilidade">Email da Contabilidade</label>
                        <input type="emailContabilidade" name="emailContabilidade" value={formData.emailContabilidade} disabled/>
                    </div>
                </div>

                {/* Linha Código Cliente, Proprietário, Potência */}
                <div className={styles.linhaUsina3}>
                    <div className={styles_content.formField}>
                        <label htmlFor="codCliente">Cod. Cliente</label>
                        <input type="text" name="codCliente" value={formData.codCliente} disabled />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="idUsuarioProprietario">Proprietário</label>
                        <select name="idUsuarioProprietario" value={formData.idUsuarioProprietario} disabled>
                            <option value="">Selecionar Usuário</option>
                            {usuarios.map((usuario) => (
                                <option key={usuario.id} value={usuario.id}>{usuario.nome}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="potencia">Média de Geração Mensal kwh</label>
                        <input type="text" name="potencia" value={formatarKwh10_2(formData.potencia)} disabled />
                    </div>
                </div>

                {/* Linha Endereço */}
                <div className={styles.linhaUsina3}>
                    <div className={styles_content.formField}>
                        <label htmlFor="cep">CEP</label>
                        <InputMask
                            mask="99999-999"
                            maskChar=""
                            type="text"
                            name="cep"
                            value={formData.cep}
                            disabled
                        />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="endereco">Endereço</label>
                        <input type="text" name="endereco" value={formData.endereco} disabled />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="complementoEndereco">Complemento</label>
                        <input type="text" name="complementoEndereco" value={formData.complementoEndereco} disabled />
                    </div>
                </div>

                {/* Linha Bairro, UF, Município */}
                <div className={styles.linhaUsina3}>
                    <div className={styles_content.formField}>
                        <label htmlFor="bairro">Bairro</label>
                        <input type="text" name="bairro" value={formData.bairro} disabled />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="uf">UF</label>
                        <input type="text" name="uf" value={formData.uf} disabled />
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="municipio">Município</label>
                        <input type="text" name="municipio" value={formData.municipio} disabled />
                    </div>
                </div>

                {/* Linha Pix */}
                <div className={styles.linhaUsina3}>
                    <div className={styles_content.formField}>
                        <label>Tipo de Usina</label>
                        <select value={formData.idTipoUsina} disabled>
                            <option value="">Selecionar Tipo de Usina</option>
                            {tiposUsina.map(tipo => (
                                <option key={tipo.id} value={tipo.id}>{tipo.descricao}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="tipoChavePix">Tipo de Chave Pix</label>
                        <select name="tipoChavePix" value={formData.tipoChavePix} disabled>
                            <option value="0">Selecione o tipo</option>
                            <option value="1">CPF</option>
                            <option value="2">CNPJ</option>
                            <option value="3">Telefone</option>
                            <option value="4">E-mail</option>
                            <option value="5">Chave Aleatória</option>
                        </select>
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="chavePix">Chave Pix</label>
                        <InputMask
                            mask={getPixMask()}
                            maskChar=""
                            type="text"
                            name="chavePix"
                            value={formData.chavePix}
                            disabled
                        />
                    </div>
                </div>

                {String(formData.idTipoUsina) !== '2' && formData.idTipoUsina && (
                    <div className={styles.linhaUsina3}>
                        <div className={styles_content.formField}>
                            <label htmlFor="senhaDistribuidora">Senha da Distribuidora*</label>
                            <div className={styles.passwordContainer}>
                                <input
                                    type={showSenha ? 'text' : 'password'}
                                    id="senhaDistribuidora"
                                    value={formData.senhaDistribuidora}
                                    onChange={(e) => setFormData(p => ({...p, senhaDistribuidora: e.target.value}))}
                                    autoComplete="new-password"
                                    disabled
                                />

                            </div>
                        </div>

                        <div className={styles_content.formField}>
                            <label htmlFor="cpfResponsavel">CPF do Responsável*</label>
                            <div>
                                <InputMask
                                    mask="999.999.999-99"
                                    maskChar=""
                                    id="cpfResponsavel"
                                    name="cpfResponsavel"
                                    value={formData.cpfResponsavel}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* Linha Asaas */}
                <div className={styles.linhaUsina2}>
                    <div className={styles_content.formField}>
                        <label htmlFor="chaveAsaas">Chave API Asaas</label>
                        <input type="text" name="chaveAsaas" value={formData.chaveAsaas} disabled/>
                    </div>
                    <div className={styles_content.formField}>
                        <label htmlFor="numeroCarteira">Número Carteira</label>
                        <input type="text" name="numeroCarteira" value={formData.numeroCarteira} disabled />
                    </div>
                </div>
                {/* Botão de voltar */}
                <div className={styles_content.buttonGroup}>
                    <button
                        type="button"
                        onClick={() => navigate('/home/listar-usina')}
                    >
                        Voltar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default DetalharUsina;
